import { Product } from './product.model';

export class ProductSettings {
  id: string;
  product: Product;
  description: string;
  minimumAge: number;
  maximumAge: number;
  minimumOperationAmount: number;
  maximumTotalAmount: number;
  minimumInstallmentAmount: number;
  maximumInstallmentAmount: number;
  minimumInstallmentsCount: number;
  maximumInstallmentsCount: number;
  insuranceEnabled: boolean;
  insurancePremiumRate: number;
  maximumInsurancePremiumAmount: number;
  iofFixedRate: number;
  iofReducedRate: number;
  iofLimitReducedRate: number;
  iofDailyRate: number;
  dailyDelayRestriction: number;
  maximumInstallmentAmountPercentage: number;
  overdueInterest: number;
  overdueFine: number;
  createdBy: Date;
  modifiedBy: Date;

  constructor(data: any | ProductSettings | DjangoProductSettings = {}) {
    if (data instanceof ProductSettings) {
      bindProductSettingsData(this, data);
    } else {
      bindDjangoProductSettingsData(this, data);
    }
  }
}

function bindProductSettingsData(productSettings: ProductSettings, data: ProductSettings) {
  productSettings.id = data.id;
  productSettings.description = data.description;
  productSettings.minimumAge = data.minimumAge;
  productSettings.maximumAge = data.maximumAge;
  productSettings.minimumOperationAmount = data.minimumOperationAmount;
  productSettings.maximumTotalAmount = data.maximumTotalAmount;
  productSettings.minimumInstallmentAmount = data.minimumInstallmentAmount;
  productSettings.maximumInstallmentAmount = data.maximumInstallmentAmount;
  productSettings.minimumInstallmentsCount = data.minimumInstallmentsCount;
  productSettings.maximumInstallmentsCount = data.maximumInstallmentsCount;
  productSettings.insuranceEnabled = data.insuranceEnabled;
  productSettings.insurancePremiumRate = data.insurancePremiumRate;
  productSettings.maximumInsurancePremiumAmount = data.maximumInsurancePremiumAmount;
  productSettings.iofFixedRate = data.iofFixedRate;
  productSettings.iofReducedRate = data.iofReducedRate;
  productSettings.iofLimitReducedRate = data.iofLimitReducedRate;
  productSettings.iofDailyRate = data.iofDailyRate;
  productSettings.dailyDelayRestriction = data.dailyDelayRestriction;
  productSettings.maximumInstallmentAmountPercentage = data.maximumInstallmentAmountPercentage;
  productSettings.overdueInterest = data.overdueInterest;
  productSettings.overdueFine = data.overdueFine;
  productSettings.createdBy = data.createdBy;
  productSettings.modifiedBy = data.modifiedBy;
}

function bindDjangoProductSettingsData(
  productSettings: ProductSettings,
  data: DjangoProductSettings,
) {
  (productSettings.id = data.id), (productSettings.description = data.description);
  productSettings.minimumAge = data.minimum_age;
  productSettings.maximumAge = data.maximum_age;
  productSettings.minimumOperationAmount = data.minimum_operation_amount;
  productSettings.maximumTotalAmount = data.maximum_total_amount;
  productSettings.minimumInstallmentAmount = data.minimum_installment_amount;
  productSettings.maximumInstallmentAmount = data.maximum_installment_amount;
  productSettings.minimumInstallmentsCount = data.minimum_installments_count;
  productSettings.maximumInstallmentsCount = data.maximum_installments_count;
  productSettings.insuranceEnabled = data.insurance_enabled;
  productSettings.insurancePremiumRate = data.insurance_premium_rate;
  productSettings.maximumInsurancePremiumAmount = data.maximum_insurance_premium_amount;
  productSettings.iofFixedRate = data.iof_fixed_rate;
  productSettings.iofReducedRate = data.iof_reduced_rate;
  productSettings.iofLimitReducedRate = data.iof_limit_reduced_rate;
  productSettings.iofDailyRate = data.iof_daily_rate;
  productSettings.dailyDelayRestriction = data.daily_delay_restriction;
  productSettings.maximumInstallmentAmountPercentage = data.maximum_installment_amount_percentage;
  productSettings.overdueInterest = data.overdue_interest;
  productSettings.overdueFine = data.overdue_fine;
  productSettings.createdBy = data.created_by;
  productSettings.modifiedBy = data.modified_by;
}

export interface DjangoProductSettings {
  id?: string;
  product?: Product;
  description?: string;
  minimum_age?: number;
  maximum_age?: number;
  minimum_operation_amount?: number;
  maximum_total_amount?: number;
  minimum_installment_amount?: number;
  maximum_installment_amount?: number;
  minimum_installments_count?: number;
  maximum_installments_count?: number;
  insurance_enabled?: boolean;
  insurance_premium_rate?: number;
  maximum_insurance_premium_amount?: number;
  iof_fixed_rate?: number;
  iof_reduced_rate?: number;
  iof_limit_reduced_rate?: number;
  iof_daily_rate?: number;
  daily_delay_restriction?: number;
  maximum_installment_amount_percentage?: number;
  overdue_interest?: number;
  overdue_fine?: number;
  created_by?: Date;
  modified_by?: Date;
}

export function parseDjangoProductSettings(data?: DjangoProductSettings) {
  if (data) {
    return bindDjangoProductSettingsData(this, data);
  } else {
    return undefined;
  }
}

export function parseProductSettings(data?: ProductSettings) {
  if (data) {
    return this.bindProductSettingsData(data);
  } else {
    return undefined;
  }
}
